import { DialogTitle } from '@mui/material';
import React from 'react';
import { CloseButton } from './CloseButton';

export const ModalHeader = ({
                                onClose, children, className = '', iconSize, isCloseDisabled = false
                            }: {
    children?: any,
    className?: string,
    iconSize?: string,
    isCloseDisabled?: boolean,
    onClose: () => void
}) => (
  <DialogTitle
        className={className}
        sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            paddingRight: '16px',
            position: 'relative'
        }}
    >
    {children}
    <CloseButton
            iconSize={iconSize}
            isCloseDisabled={isCloseDisabled}
            onClose={onClose}
        />
  </DialogTitle>
);
